/**
 * View: seletor de tipo de proposta.
 * Mostra cards pros 8 tipos disponíveis. Click → /propostas/nova?tipo=<tipo>
 */

import { escapeHtml, renderLayout } from '../layout.js';

interface OpcaoTipo {
  tipo: string;
  titulo: string;
  descricao: string;
  prefixo: string;
}

const OPCOES: OpcaoTipo[] = [
  {
    tipo: 'contrato-recorrente',
    titulo: 'Contrato recorrente',
    descricao: 'Gestão de TI mensal (essencial, professional, premium) com pacotes adicionais.',
    prefixo: 'CONT',
  },
  {
    tipo: 'renovacao-recorrente',
    titulo: 'Renovação de contrato',
    descricao:
      'Renovação de contrato Omie existente. Importa itens do contrato original e aplica reajuste.',
    prefixo: 'REN',
  },
  {
    tipo: 'projeto-infra',
    titulo: 'Projeto de infraestrutura',
    descricao: 'Servidores, redes, datacenter, cabeamento, virtualização.',
    prefixo: 'PROJ',
  },
  {
    tipo: 'projeto-cftv',
    titulo: 'Projeto de CFTV',
    descricao: 'Câmeras, NVR, monitoramento, instalação e configuração.',
    prefixo: 'PROJ',
  },
  {
    tipo: 'projeto-controle-acesso',
    titulo: 'Projeto de controle de acesso',
    descricao: 'Catracas, leitoras, biometria, integração com sistemas.',
    prefixo: 'PROJ',
  },
  {
    tipo: 'venda-projeto-servico',
    titulo: 'Projeto/Serviço (Firewall, Migração M365, etc.)',
    descricao:
      'Implantação de firewall, migração de e-mail, organização de rack, consultoria, recuperação de desastre.',
    prefixo: 'SERV',
  },
  {
    tipo: 'venda-pecas',
    titulo: 'Venda de peças',
    descricao: 'Memória, HD, SSD, fontes, periféricos.',
    prefixo: 'VEND',
  },
  {
    tipo: 'venda-computador',
    titulo: 'Venda de computador',
    descricao: 'Desktops, notebooks, workstations completas.',
    prefixo: 'VEND',
  },
  {
    tipo: 'venda-distribuidor',
    titulo: 'Venda — Distribuidor',
    descricao: 'Compra por outros revendedores ou parceiros.',
    prefixo: 'VEND',
  },
];

export function renderSeletorTipoProposta(): void {
  const $app = document.getElementById('app');
  if (!$app) return;

  const cards = OPCOES.map(
    (o) => `
    <a href="/propostas/nova?tipo=${encodeURIComponent(o.tipo)}" data-route class="tipo-card">
      <div class="tipo-card-prefixo">${escapeHtml(o.prefixo)}</div>
      <h3>${escapeHtml(o.titulo)}</h3>
      <p>${escapeHtml(o.descricao)}</p>
    </a>
  `,
  ).join('');

  $app.innerHTML = renderLayout({
    title: 'Nova proposta',
    activeNav: 'propostas',
    bodyHtml: `
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:var(--sp-6)">
        <h1 style="font-family:var(--font-display);font-size:var(--fs-3xl);margin:0">Qual tipo de proposta?</h1>
        <a href="/propostas" data-route class="btn btn-secondary">Cancelar</a>
      </div>
      <div class="tipo-grid">${cards}</div>
    `,
  });

  injectStyles();
}

let injected = false;
function injectStyles(): void {
  if (injected) return;
  injected = true;
  const style = document.createElement('style');
  style.textContent = `
    .tipo-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: var(--sp-4);
    }
    .tipo-card {
      display: block;
      padding: var(--sp-5);
      background: var(--color-surface);
      border: 1px solid var(--color-border);
      border-radius: 8px;
      text-decoration: none;
      color: inherit;
      transition: all 0.15s;
    }
    .tipo-card:hover {
      border-color: var(--color-primary);
      box-shadow: var(--shadow-md);
      transform: translateY(-2px);
    }
    .tipo-card-prefixo {
      display: inline-block;
      font-family: var(--font-mono);
      font-size: var(--fs-xs);
      background: var(--color-primary);
      color: #fff;
      padding: 2px 8px;
      border-radius: var(--radius-full);
      margin-bottom: var(--sp-3);
      font-weight: 600;
    }
    .tipo-card h3 {
      font-family: var(--font-display);
      font-size: var(--fs-lg);
      margin: 0 0 var(--sp-2);
      color: var(--color-text);
    }
    .tipo-card p {
      font-size: var(--fs-sm);
      color: var(--color-text-secondary);
      margin: 0;
      line-height: 1.5;
    }
  `;
  document.head.appendChild(style);
}
